(ns pfo.category.component
  (:require [reagent.core :as reagent :refer [atom]]
            [reagent.ratom :refer-macros [run!]]
            [pfo.util :as util :refer [reset-from-event]]
            [pfo.form :refer [set-selected option-value with-disabled]]
            [pfo.common.component :as common]
            [pfo.collection.model :as collection-model]
            [promesa.core :as p]
            [pfo.state :refer [ui-state]]
            [pfo.scope.scope :refer [scope level-family]]
            [pfo.api :refer [process-error]]
            [pfo.widget.autocomplete :refer [react-select-styles]]
            [pfo.category.model :as model]
            [pfo.auth.model :as auth-model]
            ["react-select" :default Select]))


(defn category-chooser [options scope-atom value-atom category-type]
  (let [category-list (atom [])
        load-categories (fn [scope]
                          (->> (model/category-list scope (or category-type "s"))
                               (p/map (fn [categories-response]
                                        (reset! category-list (if-let [additional-categories (:additional-categories options)]
                                                                (into [] (concat categories-response
                                                                                 (let [existing-ids (into #{} (map :id categories-response))]
                                                                                   (filterv #(not (contains? existing-ids (:id %))) additional-categories))))
                                                                categories-response))
                                        (some-> (:categories-loaded-cb options) (apply categories-response []))))
                               (process-error)))]
    (add-watch scope-atom :category-chooser-group (fn [_ _ _ new-scope]
                                                  (load-categories new-scope)
                                                  (reset! value-atom nil)))
    (load-categories @scope-atom)
    (fn [options _ value-atom _]

      [:select (with-disabled (:disabled options) {:on-change (reset-from-event value-atom) :value @value-atom})
       [:option {:value ""} (if (:disabled options) "" "-- Choose Category --")]
       (doall
         (for [cat @category-list]
           [:option {:value (str (:id cat))
                     :key (model/category-key cat)}
            (util/add-inactive-to-name cat)]))])))


(defn category-chooser-fuzzy [options group-id value-atom category-type]
  (let [category-list (atom [])
        categories-format (fn [categories]
                            (mapv
                              (fn [category]
                                {:label (str (:name category) (when-not (:active category) " (inactive)"))
                                 :value (:id category)})
                              categories))
        load-categories (fn [group-id]
                          (->> (model/category-list (scope level-family group-id) (or category-type "s"))
                               (p/map (fn [categories-response]
                                        (reset! category-list
                                                (categories-format
                                                  (if-let [additional-categories (:additional-categories options)]
                                                    (into [] (concat categories-response
                                                                     (let [existing-ids (into #{} (map :id categories-response))]
                                                                       (filterv #(not (contains? existing-ids (:id %))) additional-categories))))
                                                    categories-response)))))
                               (process-error)))
        _ (load-categories @group-id)]

    (add-watch group-id :category-chooser-group-fuzzy (fn [_ _ _ new-group-id]
                                                        (load-categories new-group-id)
                                                        (reset! value-atom nil)))

    (fn [options group-id value-atom category-type]
      [:> Select 
       (merge 
         {:options @category-list
         :placeholder "Select category"
         :value (filter (fn [category] (= @value-atom (:value category)))  @category-list)
         :on-change (fn [x] (reset! value-atom (-> (js->clj x :keywordize-keys true) :value)))}
         (:primary react-select-styles))])))

(defn add-to-column [columns index item]
  (assoc columns index (conj (nth columns index) item)))

;; TODO: this is written in a very non-performant, procedural way.
;; Should be rewritten in a functional way, avoiding costly state modifications.
(defn split-to-columns [grouped-items total-count num-columns]
  (let [opt-column-size (.ceil js/Math (/ total-count num-columns))
        current-column (clojure.core/atom 0)
        current-column-num-items (clojure.core/atom 0)
        columns (clojure.core/atom [])]
    (doall
      (for [[grouper group] grouped-items]
        (do (when (< (dec (count @columns)) @current-column)
              (swap! columns conj []))
            (swap! columns add-to-column @current-column [grouper group])
            (swap! current-column-num-items + (count group))
            (when (>= @current-column-num-items opt-column-size)
              (do (swap! current-column inc)
                  (reset! current-column-num-items 0))))))
    @columns))

(defn grouped-categories [categories link-fn]
  (let [grouped (sort (into [] (group-by #(first (:name %)) categories)))
        split (split-to-columns grouped (count categories) 3)]

    [:div.o-3-columns
     (for [column split]
       (doall
         (for [[letter category-group] column]
           [:ul.u-margin-bottom.o-3-columns__break-inside--avoid {:key (gensym letter)}
            [:h3 letter]
            (doall
              (for [category category-group]
                [:li {:key (:id category)}
                 (if (> (:objects_in_category category) 0)
                   [:a {:href "javascript:void(0)"
                        :on-click (util/handler #(link-fn (:id category)))} (:name category)]
                   [:span.u-color--secondary (:name category)])]))])))]))

(defn category-list []
  (let [groups (atom nil)
        group (atom nil)
        categories (atom {})
        has-service-perm? #(or
                             (auth-model/has-family-perm @group :can_view_task)
                             (auth-model/has-family-perm @group :can_view_compliance))
        has-data-perm? #(auth-model/has-family-perm @group :can_view_document)
        load-categories (fn [group-id]
                          (->> (p/all [(if (has-service-perm?)
                                         (model/category-list (scope level-family group-id) "s" "name" true)
                                         (p/promise nil))
                                       (if (has-data-perm?)
                                         (model/category-list (scope level-family group-id) "d" "name" true)
                                         (p/promise nil))])
                            (p/map (fn [[service data]]
                                     (reset! categories {:data data
                                                         :service service})))
                            (process-error)))
        family-chooser #(when (> (count @groups) 0)
                          [:span "Select Family: "
                           [:select {:on-change (fn [ev]
                                                  ((reset-from-event group) ev)
                                                  (load-categories @group))}
                            (doall
                              (for [gr @groups]
                                [:option (option-value @group (:id gr)) (util/add-inactive-to-name gr)]))]])]
    (->>
      (collection-model/collection-list-promise nil false)
      (p/map (fn [response]
               (let [response-groups (filter #(model/categories-view-permitted (:id %)) response)]
                 (reset! groups response-groups)
                 (reset! group (:id (first response-groups)))
                 (load-categories @group))))
      (process-error))

    (fn []
      (when @group
        [:div
         (when (:service @categories)
           [common/header-tab-wrapper
            [:span [:img.tab-header {:src "/static/img/icons/category.svg"}] "Service categories"]
            [:div.o-media.u-white-background
             [grouped-categories (:service @categories) (fn [id]
                                                          (util/set-location
                                                            (str
                                                              "#/task/list?task_type=all&all-filter="
                                                              (util/base64-url-marshal {:category-id #{[id]}
                                                                                        :include-subcollections true
                                                                                        :collection-id @group}))))]]
            [family-chooser]])
         (when (:data @categories)
           [common/header-tab-wrapper
            [:span [:img.tab-header {:src "/static/img/icons/category.svg"}] "Document categories"]
            [:div.o-media.u-white-background
             [grouped-categories (:data @categories) (fn [id]

                                                       (swap! ui-state assoc :document-filter-categories #{[id]} :hide-filter true)
                                                       (util/set-location (str "#/document/list?collection_id=" @group)))]]
            (when-not (has-service-perm?)
              [family-chooser])])
         nil]))))
